<template>
  <div class="show-user">
    <div class="boo">
      <div class="user" v-if="loginInfo && loginInfo.name">
        <img
          :src="headLogo"
          :class="[
            loginInfo.name ? 'mr15 user-head-login' : 'mr16 user-head-out'
          ]"
        />
        <div>
          <template v-if="loginInfo && loginInfo.name">
            <div
              v-if="loginInfo && loginInfo.orgName"
              style="font-size: 14px; cursor: pointer; color: rgb(0, 137, 239)"
              class="user-type-welcome ell"
              :title="loginInfo.orgName"
            >
              {{ loginInfo.orgName }}
            </div>

            <div
              class=""
              style="
                display: block;
                cursor: pointer;
                font-size: 14px;
                color: rgb(0, 137, 239);
              "
              v-if="options && options.length > 1"
              @click="checkOrg"
            >
              <el-select
                style="height: 28px !important"
                v-model="form.value"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.supCode || ''"
                  :label="item.supName || ''"
                  :value="item.supCode || ''"
                  @click.native="changeCompany(item)"
                >
                </el-option>
              </el-select>
            </div>
            <div
              class=""
              style="display: block; cursor: pointer; font-size: 14px"
              v-else
              @click="checkOrg"
            >
              {{ (options && options[0] && options[0].supName) || "" }}
            </div>
          </template>
          <!-- <template v-else>
            <div class="user-type-welcome">
              {{ $t("page.content.supplierLogin") }}
            </div>
            <a class="user-type-link" @click="handleLogin"
              >{{ $t("page.content.pleaseLogin") }}>
          
            </a>
          </template> -->
        </div>
      </div>
      <div class="card" @click="submit">
        <span>交建云商密码找回申请入口</span>
      </div>

      <div class="ccui-clearfix">
        <template v-for="(item, index) in imgData">
          <a :key="index" @click="handleHelp(item)"
            ><img
              :src="item.coverUrl"
              :style="{
                width: item.width + 'px',
                height: item.height + 'px'
              }"
              class="fl help-center-img"
          /></a>
        </template>
      </div>
    </div>
    <!-- <div class="user-divider"></div> -->

    <div class="byp">
      <div
        v-if="loginInfo && loginInfo.name"
        class="announcements-title ccui-clearfix"
      >
        <span class="fl">
          <i style="margin-right: 2px" class="icon-ccui-trumpet"></i>
          <!-- <svg-icon icon-class="trumpet" class="icon-trumpet"></svg-icon
          > -->
          <span class="">{{ $t("page.content.Announcements1") }}</span></span
        >
        <el-link
          :underline="false"
          type="info"
          class="fr color-1"
          @click="handleViewAll()"
          >{{ $t("page.content.MoreAndMore") }} ></el-link
        >
      </div>
      <ul v-if="loginInfo && loginInfo.name" class="announcements-ul">
        <template v-for="(item, index) in pageData">
          <li :key="index" class="ellipsis announcements-ul-li">
            <a @click="handleOp(item)" class="ellipsis" :title="item.title">{{
              item.title
            }}</a>
          </li>
        </template>
      </ul>
    </div>
    <!-- 提交弹框 -->
    <submitDialog ref="submitDialog" />
  </div>
</template>

<script>
import submitDialog from "./submitDialog";
import { queryPublishedNoticeList, updateHits } from "@/app/shop/api/shopping";
import Cookies from "js-cookie";
export default {
  name: "showUser",
  props: {
    imgData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      pageData: [],
      supInfo: this.$store.state.user.supInfo || {},
      form: {
        value: ""
      },
      options: [],
      supName: "",
      encSupCode: ""
    };
  },
  components: {
    submitDialog
  },
  activated() {
    console.log(this.supInfo, "this.supInfo");
    let supInfo = null;
    if (this.supInfo && this.supInfo.getSupInfoByLoginInfoRspBOList.length) {
      this.options = this.supInfo.getSupInfoByLoginInfoRspBOList;
    }
    if (
      this.supInfo &&
      this.supInfo.getSupInfoByLoginInfoRspBOList.length > 1
    ) {
      this.form.value = this.supInfo.getSupInfoByLoginInfoRspBOList[0].supCode;
      this.supName =
        this.supInfo.getSupInfoByLoginInfoRspBOList[0].supName || "";
      this.encSupCode = this.supInfo.getSupInfoByLoginInfoRspBOList[0].encSupCode;
      supInfo = {
        corpSupSituation: "",
        getSupInfoByLoginInfoRspBOList: [
          {
            corpSupSituation: "",
            getSupInfoByLoginInfoRspBOList: [],
            isOverseas: 0,
            secretAgentId: this.supInfo.getSupInfoByLoginInfoRspBOList[0]
              .secretAgentId,
            purSupFlag: this.supInfo.getSupInfoByLoginInfoRspBOList[0]
              .purSupFlag,
            supCode: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supCode,
            encSupCode: this.supInfo.getSupInfoByLoginInfoRspBOList[0]
              .encSupCode,
            supName:
              this.supInfo.getSupInfoByLoginInfoRspBOList[0].supName || "",
            supinfoId: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supinfoId
          }
        ],
        isOverseas: 0,
        secretAgentId: this.supInfo.getSupInfoByLoginInfoRspBOList[0]
          .secretAgentId,
        purSupFlag: this.supInfo.getSupInfoByLoginInfoRspBOList[0].purSupFlag,
        supCode: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supCode,
        encSupCode: this.supInfo.getSupInfoByLoginInfoRspBOList[0].encSupCode,
        supName: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supName || "",
        supinfoId: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supinfoId
      };
      localStorage.supInfo = JSON.stringify(supInfo);
      this.$store.dispatch("user/setsupinfo", supInfo);
      //存储默认值
      localStorage.setItem("usedSupInfo", JSON.stringify(supInfo));
      this.$emit("getSupCode", {
        name: this.supName,
        code: this.form.value,
        encSupCode: this.encSupCode
      });
    } else {
      if (
        this.supInfo &&
        this.supInfo.getSupInfoByLoginInfoRspBOList.length > 0
      ) {
        supInfo = {
          corpSupSituation: "",
          getSupInfoByLoginInfoRspBOList: [
            {
              corpSupSituation: "",
              getSupInfoByLoginInfoRspBOList: [],
              isOverseas: 0,
              secretAgentId: this.supInfo.getSupInfoByLoginInfoRspBOList[0]
                .secretAgentId,
              purSupFlag:
                this.supInfo.getSupInfoByLoginInfoRspBOList[0].purSupFlag || "",
              supCode:
                this.supInfo.getSupInfoByLoginInfoRspBOList[0].supCode || "",
              supName:
                this.supInfo.getSupInfoByLoginInfoRspBOList[0].supName || "",
              encSupCode:
                this.supInfo.getSupInfoByLoginInfoRspBOList[0].encSupCode || "",
              supinfoId:
                this.supInfo.getSupInfoByLoginInfoRspBOList[0].supinfoId || ""
            }
          ],
          isOverseas: 0,
          secretAgentId: this.supInfo.getSupInfoByLoginInfoRspBOList[0]
            .secretAgentId,
          purSupFlag:
            this.supInfo.getSupInfoByLoginInfoRspBOList[0].purSupFlag || "",
          supCode: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supCode || "",
          encSupCode:
            this.supInfo.getSupInfoByLoginInfoRspBOList[0].encSupCode || "",
          supName: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supName || "",
          supinfoId:
            this.supInfo.getSupInfoByLoginInfoRspBOList[0].supinfoId || ""
        };
      } else {
        supInfo = {
          corpSupSituation: "",
          getSupInfoByLoginInfoRspBOList: [
            {
              corpSupSituation: "",
              getSupInfoByLoginInfoRspBOList: [],
              isOverseas: 0,
              secretAgentId: "",
              purSupFlag: "",
              supCode: "",
              supName: "",
              encSupCode: "",
              supinfoId: ""
            }
          ],
          isOverseas: 0,
          secretAgentId: "",
          purSupFlag: "",
          supCode: "",
          encSupCode: "",
          supName: "",
          supinfoId: ""
        };
      }
      localStorage.supInfo = JSON.stringify(supInfo);
      this.$store.dispatch("user/setsupinfo", supInfo);
      //存储默认值
      localStorage.setItem("usedSupInfo", JSON.stringify(supInfo));
      this.$emit("getSupCode", {
        name: this.supInfo.supName || "",
        code: this.supInfo.supCode || "",
        encSupCode: this.supInfo.encSupCode || ""
      });
    }
    this.init();
  },
  deactivated() {},
  methods: {
    submit() {
      this.$refs.submitDialog.dialogVisible = true;
    },

    changeCompany(item) {
      this.form.value = item.supCode;
      this.supName = item.supName || "";
      this.$emit("getSupCode", {
        name: this.supName,
        code: this.form.value,
        encSupCode: item.encSupCode
      });
      let supInfo = {
        corpSupSituation: "",
        getSupInfoByLoginInfoRspBOList: [
          {
            corpSupSituation: "",
            getSupInfoByLoginInfoRspBOList: [],
            isOverseas: 0,
            secretAgentId: item.secretAgentId,
            purSupFlag: item.purSupFlag,
            supCode: item.supCode,
            supName: item.supName || "",
            encSupCode: item.encSupCode,
            supinfoId: item.supinfoId
          }
        ],
        isOverseas: 0,
        secretAgentId: item.secretAgentId,
        purSupFlag: item.purSupFlag,
        supCode: item.supCode,
        encSupCode: item.encSupCode,
        supName: item.supName || "",
        supinfoId: item.supinfoId
      };
      localStorage.supInfo = JSON.stringify(supInfo);
      // 每切换一次存本地
      localStorage.setItem("usedSupInfo", JSON.stringify(supInfo));

      this.$store.dispatch("user/setsupinfo", supInfo);
      this.init();
    },

    init() {
      queryPublishedNoticeList({
        agentId: 100131,
        pageNo: 1,
        pageSize: 5,
        module: 1,
        pageState: 2,
        appId: 100131
      }).then(res => {
        if (res.data.code === "0") {
          this.pageData = res.data.data.rows;
        }
      });
    },
    handleHelp(item) {
      //点击量
      updateHits({
        publicityContentId: item.publicityContentId
      });
      window.open(item.otherUrl, "_blank");
    },
    //更多 >
    handleViewAll() {
      let url = this.$router.resolve({
        path: "/announcementsList"
      });
      window.open(url.href, "_blank");
    },
    handleOp(row) {
      let url = this.$router.resolve({
        path: "/announcementDetail",
        query: {
          id: row.noticeInfoId,
          type: this.type
        }
      });
      window.open(url.href, "_blank");
    },
    // 切换单位
    checkOrg() {},
    //退出
    handleExit() {
      localStorage.clear();
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
      // window.location.href = "/login";

      //跳转分包商门户
      // window.location.href =
      //   this.$addUrlPerFix("mla.iccec.cn/apis/mla/users/signup/doLogout") +
      //   "?ACCESS_TOKEN=" +
      //   Cookies.get("access_token") +
      //   "&redirectUrl=" +
      //   encodeURIComponent(
      //     this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) + "/login"
      //   );
      //跳转basa登录
      // window.location.href =
      //   this.$addUrlPerFix("mla.iccec.cn/apis/mla/users/signup/doLogout") +
      //   "?ACCESS_TOKEN=" +
      //   Cookies.get("access_token") +
      //   "&redirectUrl=" +
      //   encodeURIComponent(this.$addUrlPerFix(process.env.VUE_APP_LOGIN));
      //跳转交建云商门户
      window.location.href =
        this.$addUrlPerFix("mla.iccec.cn/apis/mla/users/signup/doLogout") +
        "?ACCESS_TOKEN=" +
        Cookies.get("access_token") +
        "&redirectUrl=" +
        encodeURIComponent(this.$addUrlPerFix(process.env.VUE_APP_EMP_URL));
    },
    //登录
    handleLogin() {
      // window.location.href = "/login";
      window.location.href =
        this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
        "?redirectUrl=" +
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
    }
  },
  computed: {
    loginInfo() {
      return this.$store.getters.getLoginInfo;
    },
    headLogo() {
      if (this.loginInfo.iConLink) {
        return this.loginInfo.iConLink;
      } else {
        return require("@/basa/assets/images/headLogo.png");
      }
    }
  },
  mounted() {
    // let supInfo = null;
    // if (
    //   this.supInfo &&
    //   this.supInfo.getSupInfoByLoginInfoRspBOList.length > 1
    // ) {
    //   this.options = this.supInfo.getSupInfoByLoginInfoRspBOList;
    //   this.form.value = this.supInfo.getSupInfoByLoginInfoRspBOList[0].supCode;
    //   this.supName = this.supInfo.getSupInfoByLoginInfoRspBOList[0].supName;
    //   supInfo = {
    //     corpSupSituation: "",
    //     getSupInfoByLoginInfoRspBOList: [
    //       {
    //         corpSupSituation: "",
    //         getSupInfoByLoginInfoRspBOList: [],
    //         isOverseas: 0,
    //         purSupFlag:
    //           this.supInfo.getSupInfoByLoginInfoRspBOList[0].purSupFlag,
    //         supCode: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supCode,
    //         supName: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supName,
    //         supinfoId: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supinfoId,
    //       },
    //     ],
    //     isOverseas: 0,
    //     purSupFlag: this.supInfo.getSupInfoByLoginInfoRspBOList[0].purSupFlag,
    //     supCode: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supCode,
    //     supName: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supName,
    //     supinfoId: this.supInfo.getSupInfoByLoginInfoRspBOList[0].supinfoId,
    //   };
    //   localStorage.supInfo = JSON.stringify(supInfo);
    //   this.$store.dispatch("user/setsupinfo", supInfo);
    //   this.$emit("getSupCode", this.form.value);
    // } else {
    //   this.$emit("getSupCode", this.supInfo.supCode);
    // }
  }
};
</script>

<style scoped lang="scss">
.boo {
  background: #ffffff;
  height: 270px;
  padding-top: 10px;
  box-sizing: border-box;
}
.byp {
  margin-top: 10px;
  background: #ffffff;
  padding: 10px 15px 10px 10px;
  height: 320px;
  box-sizing: border-box;
}
.show-user {
  width: 260px;
  height: 370px;
  // background: #ffffff;
  .user {
    padding: 26px 14px 20px 12px;
    display: flex;
    align-items: center;
    .user-head-login {
      width: 53px;
      height: 53px;
    }
    .user-head-out {
      width: 52px;
      height: 52px;
    }
    .user-type-welcome {
      line-height: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-size: 20px;
      color: #4a4a4a;
      letter-spacing: 0;
      font-weight: 400;
      max-width: 165px;
    }
    .user-type-link {
      line-height: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-size: 13px;
      color: #4a4a4a;
      letter-spacing: 0;
      font-weight: 400;
      margin-top: 4px;
      display: block;
    }
    .user-type-link:hover {
      color: #0089ef;
    }
    .user-type-log-out {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999;
      margin-top: 1px;
      cursor: pointer;
      width: 30px;
    }
    .user-type-log-out:hover {
      color: #0089ef;
    }
  }
}

/deep/ .el-select .el-input--suffix .el-input__inner {
  height: 28px !important;
}

.icon-trumpet {
  width: 15.02px;
  height: 14px;
  padding-right: 7px;
}
.help-center-img {
  margin: 0 10px 10px;
}
.card {
  width: 219px;
  background-color: #e817ad;
  color: #fff;
  font-weight: 700;
  height: 39px;
  line-height: 36px;
  padding-left: 20px;
  cursor: pointer;
  margin: 0px 10px 10px 10px;
}
</style>
